import { useCallback, useEffect, useRef, useState } from "react";

const BACK_BUTTON_SELECTOR = '[data-testid="autocomplete-back"]';

/**
 * Tracks whether the postal code autocomplete is in "focused/expanded" mode
 * by observing the presence of the back button that the library renders
 * only when showPostalCodeOnly is true.
 */
export function usePostalCodeFocused(): boolean {
	const [isFocused, setIsFocused] = useState(false);
	const observerRef = useRef<MutationObserver | null>(null);

	const checkBackButton = useCallback(() => {
		setIsFocused(document.querySelector(BACK_BUTTON_SELECTOR) !== null);
	}, []);

	useEffect(() => {
		observerRef.current = new MutationObserver(checkBackButton);
		observerRef.current.observe(document.body, {
			childList: true,
			subtree: true,
		});

		checkBackButton();

		return () => {
			observerRef.current?.disconnect();
		};
	}, [checkBackButton]);

	return isFocused;
}
